import { IVideoTutorial } from "~/types/video";

export const tutorials: Array<IVideoTutorial> = [
  {
    title: "tutorial.title_1",
    duration: "0:22",
    videoUrl:
      "https://jubilee-production-frontend-app.s3.us-east-1.amazonaws.com/assets/tutorial_video/Jubilee+search+page+(1).mov",
  },
  {
    title: "tutorial.title_2",
    duration: "0:21",
    videoUrl:
      "https://jubilee-production-frontend-app.s3.us-east-1.amazonaws.com/assets/tutorial_video/Branding+(1).mov",
  },
  {
    title: "tutorial.title_3",
    duration: "0:23",
    videoUrl:
      "https://jubilee-production-frontend-app.s3.us-east-1.amazonaws.com/assets/tutorial_video/Jubilee+import+list+(1).mov",
  },
  {
    title: "tutorial.title_4",
    duration: "0:20",
    videoUrl:
      "https://jubilee-production-frontend-app.s3.us-east-1.amazonaws.com/assets/tutorial_video/jubilee+Live+Products+(1).mov",
  },
  {
    title: "tutorial.title_5",
    duration: "0:22",
    videoUrl:
      "https://jubilee-production-frontend-app.s3.us-east-1.amazonaws.com/assets/tutorial_video/Jubilee+Sample+orders+(1).mov",
  },
];
